import { render, staticRenderFns } from "./VendorWarehouseModal.vue?vue&type=template&id=0d70778a&"
import script from "./VendorWarehouseModal.vue?vue&type=script&lang=js&"
export * from "./VendorWarehouseModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports